<button
    class="custom-primary-button w-[3rem] h-[3rem]"
    [class.cursor-not-allowed]="!canAccessDataButton()"
    [disabled]="!canAccessDataButton()"
    [matTooltip]="(canAccessDataButton() ? 'manageData' : 'insufficientPermissions') | transloco"
    (click)="redirectToManagementDataPanel()">
    <fa-icon
        class="icon"
        size="xl"
        [icon]="['fas', 'database']" />
</button>
